import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getApiBaseUrl } from '../services/apiClient';
import './PublicFileDownloadPage.css';

const formatFileSize = (bytes) => {
  if (bytes == null || bytes === 0) return '0 B';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

export default function PublicFileDownloadPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = 'ÜNMAK | Dosya İndir';
    return () => {
      document.title = 'SM Yönetim Sistemi';
    };
  }, []);

  useEffect(() => {
    if (!token) {
      setError('Geçersiz link');
      setLoading(false);
      return;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      setError('');
      try {
        const url = `${getApiBaseUrl()}/api/public/files/${encodeURIComponent(token)}`;
        const res = await fetch(url);
        const json = await res.json().catch(() => ({}));

        if (cancelled) return;

        if (!res.ok || !json?.basarili || !json?.veri) {
          setError(json?.mesaj || 'Geçersiz veya süresi dolmuş link');
          return;
        }

        setData(json.veri);
      } catch {
        if (!cancelled) setError('Sayfa yüklenirken bir hata oluştu');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token]);

  const handleDownload = () => {
    if (!token) return;
    window.location.href = `${getApiBaseUrl()}/api/public/files/${encodeURIComponent(token)}/download`;
  };

  if (loading) {
    return (
      <div className="public-file-page">
        <div className="public-file-page__loading">
          <div className="public-file-page__spinner" />
          <span>Yükleniyor...</span>
        </div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="public-file-page">
        <div className="public-file-page__card public-file-page__card--error">
          <div className="public-file-page__error-icon">!</div>
          <p>{error || 'Geçersiz veya süresi dolmuş link'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="public-file-page">
      <header className="public-file-page__header">
        <div className="public-file-page__brand">
          <img
            src="/assets/img/logo.png"
            alt="Ünmak"
            className="public-file-page__logo"
          />
        </div>
      </header>

      <main className="public-file-page__main">
        <div className="public-file-page__card">
          <div className="public-file-page__file-icon">
            <i className="fas fa-file-arrow-down" />
          </div>
          <h1 className="public-file-page__title">Dosya indir</h1>
          <p className="public-file-page__filename">{data.originalFilename}</p>
          <p className="public-file-page__meta">{formatFileSize(data.size)}</p>
          <button type="button" className="public-file-page__download-btn" onClick={handleDownload}>
            <i className="fas fa-download" />
            Dosyayı İndir
          </button>
        </div>
      </main>
    </div>
  );
}
